import { render, staticRenderFns } from "./ComplieHeaderMind.vue?vue&type=template&id=20ce87ba&scoped=true"
import script from "./ComplieHeaderMind.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderMind.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderMind.vue?vue&type=style&index=0&id=20ce87ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce87ba",
  null
  
)

export default component.exports